// @flow
import moment from 'moment';
import {REMINDER_INTERVALS} from 'modules/group/constants';

export const getDateRange = (
  numberBeforeToday: number,
  numberAfterToday: number,
  period: string = 'd',
): {start: string, end: string} => {
  const start = moment().subtract(numberBeforeToday, period).toISOString();
  const end = moment().add(numberAfterToday, period).toISOString();

  return {
    start,
    end,
  };
};

// rbc onRangeChange: array of day Dates (week/day) or {start, end} (month/agenda)
export const normalizeVisibleRange = (
  range: Array<Date> | {start: Date, end: Date},
): {start: string, end: string} => {
  if (Array.isArray(range)) {
    return {
      start: moment(range[0]).toISOString(),
      end: moment(range[range.length - 1])
        .endOf('day')
        .toISOString(),
    };
  }

  return {
    start: moment(range.start).toISOString(),
    end: moment(range.end).toISOString(),
  };
};

export const concatDateTime = (date: string, time: string): string => {
  const [hour, minute] = time.split(':');

  return moment(date)
    .set({
      hour: Number(hour),
      minute: Number(minute),
      second: 0,
      millisecond: 0,
    })
    .toISOString();
};

export const getEventDetailUrl = (
  id: string | void,
  originalStart: string | void,
): string =>
  `/calendar/calendar-event/${String(id)}?original_start=${encodeURIComponent(
    String(originalStart),
  )}`;

export const getGroupEventReminderLabel = (invitation) => {
  const {reminderTime} = invitation ?? {};
  const reminderInterval = REMINDER_INTERVALS.find(
    (interval) => interval.value === reminderTime,
  );

  return `Reminder ${reminderInterval?.label} ${reminderInterval?.interval} before`;
};
